import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { Element } from 'react-scroll';
import { propFunc, propShape, propStr, } from '../../../../../../../../helpers/custom-prop-types';
import PlainInputField from '../../../../../../../Ui/Common/Fields/PlainInputField';
import InputError from '../../../../../../../Ui/Common/InputError';
import AccountAddButton from '../../../../../Common/AccountAddButton';
const AccountBillingInformationFieldArray = (props) => {
    const { addObject, error, fields, meta, render } = props;
    const onClickDelete = useCallback((e) => {
        const index = parseInt(e.currentTarget.value, 10);
        fields.remove(index);
    }, [fields]);
    const onClickAdd = useCallback(() => {
        fields.push(addObject);
    }, [fields, addObject]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'account_form_billing_information' }, { children: [fields.length > 0 && (_jsx("div", Object.assign({ className: 'account_form_billing_information_list' }, { children: fields.map((field, index) => render({
                            field,
                            index,
                            length: fields.length,
                            onClickDelete,
                        })) }))), _jsx("div", Object.assign({ className: 'account_form_billing_information_action' }, { children: _jsx(AccountAddButton, { onClick: onClickAdd, text: '請求書送付先を追加' }) }))] })), _jsx(PlainInputField, { name: 'billingInformationArray', showError: false, type: 'hidden' }), meta.submitFailed && error && (_jsx(Element, Object.assign({ className: 'account_form_billing_information_error', name: 'billingInformationArray._error' }, { children: _jsx(InputError, { error: error }) })))] }));
};
AccountBillingInformationFieldArray.propTypes = {
    addObject: propShape().isRequired,
    error: propStr(),
    fields: propShape().isRequired,
    meta: propShape().isRequired,
    render: propFunc().isRequired,
};
AccountBillingInformationFieldArray.defaultProps = {
    error: null,
};
export default AccountBillingInformationFieldArray;
